module.exports = __webpack_public_path__ + "img/BIT_white10.cc6f5f94.jpg";